import { defineMessages } from 'react-intl';

export const messages: {
	recentSearchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeRecentSearchIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeRecentSearchSubheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recentSearchIconLabel: {
		id: 'dropdown_recent_icon_label',
		defaultMessage: 'Recent',
		description: 'Label text for recent icon',
	},
	removeRecentSearchIcon: {
		id: 'search-result.remove-recent-search',
		defaultMessage: 'Remove recent search icon',
		description: 'The icon that removes a recent search result',
	},
	removeRecentSearchSubheading: {
		id: 'search-result.remove-recent-search-result-subheading',
		defaultMessage: 'Recent search',
		description: 'Removes a recent search result',
	},
});
